














































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import requestService from "@/service/requestService";
import { ShakenShohiyou } from "@/model/shakenShohiyou";
import { Getter, Action } from "vuex-class";
import Number from "@/shared/filters/Number.ts";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import * as util from "@/service/util";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { ElForm } from "element-ui/types/form";
import { ElButton } from "element-ui/types/button";
import InputNumber from "@/components/common/input/InputNumber.vue";
import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import UserFooter from "@/components/UserFooter.vue";
import { RyoukinRank, Hikazei3, HikazeiRyoukin } from "@/model/RyoukinRank";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { Item } from "@/model/shakenShohiyou";

export interface SideTab {
  status: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    JibaiseikiDialog,
    JuuryouzeiDialog,
    UserFooter,
    TopBarTitle
  }
})
export default class InspectionCostPage extends Vue {
  isMode_modal:boolean = false;
  isMode_quick:boolean = false;
  isEditPrice: boolean = false;
  showAside: boolean = true;
  updating: boolean = false;
  currentTab: number = 1;
  reqService: requestService;
  sktControll: SocketControllers;
  isChangeShohiyou: boolean = false;
  // costData: ShakenShohiyou = {
  //   houteiHiyou: {},
  //   kensaHiyou: {},
  //   shakenHiyou: {}
  // };
  totalcostData: ShakenShohiyou = {} as ShakenShohiyou;
  isZenuki: boolean = false;
  // loading: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMsg: string = "";
  displayDialogTax: boolean = false;
  jibaiseikiTable: any = null;
  juuryouzeiKubun: any = null;
  isSetFormData: boolean = false;
  formData: JuuryouzeiJibaiseikiSave = {
    zeiJibaisekiMonthCnt: null,
    zkJibaisekiCd: null,
    zeiJibaisekiZn: null,
    zeiJibaisekiZk: null,
    zkWeightTaxCd: null,
    zeiWeightTax: null,
    zeiInshidaiZn: null,
    zeiInshidaiZk: null,
    zeiInshidaiGenka: null,
    ryoukinRankCd: null,
    isMadoguchiInshidai: 0,
    isUseTechInfoAmount: 0,
    zeiTechInfoAmountZn: null,
    zeiTechInfoAmountZk: null
  };
  listRyoukinRank: HikazeiRyoukin = { hikazei3: [], ryoukinRank: [] };
  ryoukinRankSelected: any = null;
  hikazei3KingakuSelected: any = null;
  shakenHiyouList: any = [];
  isClearFromButton: boolean = false;
  isEditKensaHiyou: boolean = false;

  isMadoguchiInshidaiChecked: boolean = false;
  inshidaiMadoguchi: number = 1200;

  confirmDialogTaxWeightMsg: string = "";
  loading: boolean = false;
  zeiWeightTaxStaging: number = 0;

  /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
  isInshidaiZero: boolean = false;
  /** 2021-12-23 sh #7620 allows to set zero yen. [END] */

  rules = {
    zeiJibaisekiZk: [{ validator: this.validatejibaiseiki, trigger: "blur" }],
    zeiJibaisekiMonthCnt: [
      { validator: this.validatejibaiseikiMonth, trigger: "blur" }
    ],
    zeiWeightTax: [{ validator: this.validatejuuryouzei, trigger: "blur" }],
    zeiInshidaiZn: [{ validator: this.validateInshidai }],
    ryoukinRankCd: [{ validator: this.validateRyoukinRank }]
  };
  userService: UserService;

  $refs!: {
    // sideTab: SideTabRight;
    errorDialog: ConfirmDialog;
    taxForm: ElForm;
    jibaiseikiDialog: JibaiseikiDialog;
    juuryouzeiDialog: JuuryouzeiDialog;
    btnConfirmTax: ElButton;
    inputKingaku: InputNumber[];
    confirmDialogTaxWeight: ConfirmDialog;
    confirmDialogTaxWeightErr: ConfirmDialog;
  };

  @Action("updateShakenHiyou", { namespace: "Shohiyou" })
  updateShakenHiyou: any;
  @Action("confirm", { namespace: "Shohiyou" })
  confirm: any;

  @Getter("hasData", { namespace: "Shohiyou" })
  hasData: boolean;
  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Action("updateRyoukinRankCd", { namespace: "ReservationDetail" })
  updateRyoukinRankCd: any;

  @Action("setEnvironment", { namespace: "Environment" })
  setEnvironment: any;
  @Getter("environment", { namespace: "Environment" })
  environment: any;

  @Getter("shohiyouLoading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("shohiyouError", { namespace: "UserDataState" })
  shohiyouError: string;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;

  @Action("updateTax", { namespace: "Shohiyou" })
  updateTax: any;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  get isError() {
    return this.shohiyouError != "";
  }

  oncloseError() {
    this.setError({ key: "shohiyou", value: "" });
  }

  created() {
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.userService = new UserService();
    /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [START] */
    // this.connectSocket(this.onConnect);
    /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [END] */
    const kyoten = window.localStorage.getItem("kyotenCd");
    if (this.environment == null && kyoten) {
      this.reqService.getEnvironment(kyoten).then((env: any) => {
        this.setEnvironment(env);
      });
    }

    this.getInspectionCostApi();
    if (window.sessionStorage.getItem("shouhiyouEditMode")) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("shouhiyouEditMode");
    }
  }

  mounted() {
    this.userService.getShohiyou(); //同期漏れがあるので画面表示で最新データをロード
    //this.$refs.sideTab.onActive(0);
    this.$emit("onActiveSideTab", 0);
    if (this.shakenHiyouList.length === 0) {
      this.onCostDataChange();
    }
  }

  onClickEdit(isEdit: boolean) {
    this.isEditPrice = isEdit;
    if (!this.isEditPrice && this.isChangeShohiyou) {
      this.onConfirm(0);
    }
  }

  @Watch("costData.shakenHiyou.items")
  onCostDataChange() {
    if (this.costData.shakenHiyou.items) {
      this.shakenHiyouList = this.costData.shakenHiyou.items.filter(data => data.shohiyouNm != '');
    }
  }

  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [START] */
  onConfirm(isConfirm: number) {
    let promise = this.updateKensaHiyouPM();
    this.$set(this, "updating", true);
    Promise.all([promise]).then(() => {
      this._onConfirm(isConfirm);
      this.$set(this, "updating", false);
    });
  }
  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [END] */

  _onConfirm(isConfirm: number) {
    let _isConfirm: any = isConfirm;
    if (isConfirm == 0) {
      _isConfirm = this.costData.isConfirm;
    }
    this.confirm(_isConfirm);
    let data = {
      isHikazei: 0, // this.costData.isHikazei, 2021-08-23 sh ひとまず、すべて課税で処理をする。（課税、非課税の切替に未対応のため）
      shakenHiyous: this.costData.shakenHiyou.items,
      sknUketsukeUserJouhou: {
        isConfirmHiyou: _isConfirm
      },
      sknUketsukeExtendsId: this.uketsukeExtendsId
    };
    sessionStorage.setItem("saveShohiyou", "1");
    this.$set(this, "updating", true);
    this.reqService.saveShohiyou(data).then(
      (res: any) => {
        this.isChangeShohiyou = false;
        this.$set(this, "updating", false);
        this.updateShakenHiyou(res);
        this.$emit("onUserConfirm");
        if (isConfirm == 1) {
          this.$router.push({ name: "option" });
        }
      },
      error => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  onSave() {
    this.onConfirm(0);
  }

  getInspectionCostApi() {
    if (!this.hasData && !this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
      //get data from api
      // this.reqService.getInsectionCost(this.uketsukeExtendsId).then(
      //   (response: any) => {
      //     if (response) {
      //       this.loading = false;
      //       const { totalZn, totalZk, isHikazei, isConfirm } = response;
      //       this.setShakenShohiyou(response);
      //       this.$set(this, "costData", { ...response });
      //       this.$set(this, "totalcostData", {
      //         totalZn,
      //         totalZk,
      //         isHikazei,
      //         isConfirm
      //       });
      //     }
      //   },
      //   (err: any) => {
      //     this.loading = false;
      //     this.onError(err);
      //   }
      // );
    }
  }

  onError(res: any) {
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  // getJibaisekiKiIsAddMonth() {
  //   if (this.environment == null) {
  //     const kyoten = window.localStorage.getItem("kyotenCd");
  //     if (kyoten) {
  //       this.reqService.getEnvironment(kyoten).then((env: any) => {
  //         this.setEnvironment(env);
  //         return Promise.resolve(env.jibaisekiKikanIkkagetsuKasan);
  //       });
  //     }
  //   } else {
  //     return Promise.resolve(this.environment.jibaisekiKikanIkkagetsuKasan);
  //   }
  //   return Promise.resolve(0);
  // }

  get zeiJibaisekiMonthCnt() {
    if (
      this.costData.houteiHiyou &&
      this.costData.houteiHiyou.zeiJibaisekiMonthCnt
    ) {
      return +this.costData.houteiHiyou.zeiJibaisekiMonthCnt;
    }
    return 0;
  }

  get isAddMonth() {
    if (this.environment) {
      return this.environment.jibaisekiKikanIkkagetsuKasan == 1;
    }
    return false;
  }

  validatejibaiseiki(rule: any, value: string, callback: any) {
    if (!this.isClearFromButton && !value) {
      callback(new Error(MESSAGE.InvalidJibaiseiki));
    } else {
      callback();
    }
  }

  validatejibaiseikiMonth(rule: any, value: string, callback: any) {
    if (!value) {
      callback(new Error(MESSAGE.InvalidJibaiseiki));
    } else {
      callback();
    }
  }

  validatejuuryouzei(rule: any, value: string, callback: any) {
    if (value == null || value === "") {
      callback(new Error(MESSAGE.InvalidJuuryouzei));
    } else {
      callback();
    }
  }

  validateInshidai(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidInshidai));
    } else {
      callback();
    }
  }

  validateRyoukinRank(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidRyoukinRank));
    } else {
      callback();
    }
  }

  onShowTax(isShow: boolean) {
    this.displayDialogTax = isShow;
    if (isShow && !this.isSetFormData) {
      this.isSetFormData = true;
      this.reqService.getRyoukinRank().then(res => {
        if (res) {
          this.listRyoukinRank = res as HikazeiRyoukin;
          // if (this.costData.houteiHiyou.zeiInshidaiZn) {
          //   const ryoukin = this.listRyoukinRank.find(
          //     e => e.hikazei3Kingaku == this.costData.houteiHiyou.zeiInshidaiZn
          //   );
          //   if (ryoukin) {
          //     this.ryoukinRankSelected = ryoukin.ryoukinRankCd;
          //     this.formData.zeiInshidaiZn = ryoukin.hikazei3Kingaku;
          //     this.formData.zeiJibaisekiZk = ryoukin.hikazei3Kingaku;
          //     this.formData.zeiInshidaiGenka = ryoukin.hikazei3Genka;
          //   }
          // }
        }
      });
      if (this.costData.houteiHiyou) {
        const houteiHiyou = this.costData.houteiHiyou;
        this.formData.zeiJibaisekiZk = houteiHiyou.zeiJibaisekiZk;
        this.formData.zeiJibaisekiZn = houteiHiyou.zeiJibaisekiZn;
        this.formData.zkJibaisekiCd = houteiHiyou.jibaisekiCd;
        this.formData.zeiJibaisekiMonthCnt = houteiHiyou.zeiJibaisekiMonthCnt;
        this.formData.zeiWeightTax = houteiHiyou.zeiWeightTax;
        this.formData.zkWeightTaxCd = houteiHiyou.weightTaxCd;
        this.ryoukinRankSelected = houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null;
        this.hikazei3KingakuSelected = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZn = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZk = houteiHiyou.zeiInshidaiZk;
        this.formData.zeiInshidaiGenka = houteiHiyou.zeiInshidaiZn;
        this.formData.ryoukinRankCd = this.ryoukinRankSelected;
        this.isMadoguchiInshidaiChecked = houteiHiyou.isMadoguchiInshidai == 1 ? true : false;
        /** 2021-09-28 sh #7438 implements tech info amount. [START] */
        this.formData.zeiTechInfoAmountZn = houteiHiyou.zeiTechInfoAmountZn;
        this.formData.zeiTechInfoAmountZk = houteiHiyou.zeiTechInfoAmountZk;
        this.formData.isUseTechInfoAmount = houteiHiyou.isUseTechInfoAmount;
        /** 2021-09-28 sh #7438 implements tech info amount. [END] */

        if (this.formData.zeiJibaisekiZk == 0) {
          this.isClearFromButton = true;
        }
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
        this.isInshidaiZero = houteiHiyou.zeiInshidaiZk == 0 ? true : false;
        if (this.isInshidaiZero){
          this.inshidaiMadoguchi = 0;
        }
        /** 2021-12-23 sh #7620 allows to set zero yen. [END] */
      }
    } else if (!isShow) {
      if (this.costData.houteiHiyou) {
        const houteiHiyou = this.costData.houteiHiyou;
        this.formData.zeiJibaisekiZk = houteiHiyou.zeiJibaisekiZk;
        this.formData.zeiJibaisekiZn = houteiHiyou.zeiJibaisekiZn;
        this.formData.zkJibaisekiCd = houteiHiyou.jibaisekiCd;
        this.formData.zeiJibaisekiMonthCnt = houteiHiyou.zeiJibaisekiMonthCnt;
        this.formData.zeiWeightTax = houteiHiyou.zeiWeightTax;
        this.formData.zkWeightTaxCd = houteiHiyou.weightTaxCd;
        this.ryoukinRankSelected = houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null;
        this.hikazei3KingakuSelected = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZn = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZk = houteiHiyou.zeiInshidaiZk;
        this.formData.zeiInshidaiGenka = houteiHiyou.zeiInshidaiZn;
        this.formData.ryoukinRankCd = this.ryoukinRankSelected;
        this.isMadoguchiInshidaiChecked = houteiHiyou.isMadoguchiInshidai == 1 ? true : false;
        /** 2021-09-28 sh #7438 implements tech info amount. [START] */
        this.formData.zeiTechInfoAmountZn = houteiHiyou.zeiTechInfoAmountZn;
        this.formData.zeiTechInfoAmountZk = houteiHiyou.zeiTechInfoAmountZk;
        this.formData.isUseTechInfoAmount = houteiHiyou.isUseTechInfoAmount;
        /** 2021-09-28 sh #7438 implements tech info amount. [END] */
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
        this.isInshidaiZero = houteiHiyou.zeiInshidaiZk == 0 ? true : false;
        if (this.isInshidaiZero){
          this.inshidaiMadoguchi = 0;
        }
        /** 2021-12-23 sh #7620 allows to set zero yen. [END] */
      }
    }
  }

  onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.displayDialogTax = false;
        this.formData.zeiJibaisekiZn = this.formData.zeiJibaisekiZk;
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
        // if (this.isMadoguchiInshidaiChecked) {
        if (this.isMadoguchiInshidaiChecked || this.isInshidaiZero) {
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
          this.formData.zeiInshidaiZn = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiZk = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiGenka = this.inshidaiMadoguchi;
        }
        this.formData.isMadoguchiInshidai = this.isMadoguchiInshidaiChecked ? 1 : 0;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
        };
        this.updateTax(this.formData);
        this.updateRyoukinRankCd(this.formData.ryoukinRankCd);
        this.displayDialogTax = false;
        /** 2021-10-01 sh #7438 implements tech info amount. [START] */
        /** 送る必要がないので、除外する */
        delete data.zeiTechInfoAmountZk;
        delete data.zeiTechInfoAmountZn;
        delete data.isUseTechInfoAmount;
        /** 2021-10-01 sh #7438 implements tech info amount. [END] */
        this.reqService.saveTax(data).then((res: any) => {
          const userService = new UserService();
          userService.getShohiyou();
        });
      }
    });
  }

  onTaxDialogOpened() {
    this.$refs.taxForm.validate();
  }

  showJibaiseikiDialog() {
    this.$refs.jibaiseikiDialog.onOpen();
    const strDate = util.getNow("YYYYMMDD");
    if (this.jibaiseikiTable == null) {
      this.reqService.getJibaisekiTable(0, strDate).then(
        (data: any) => {
          this.jibaiseikiTable = data;
          this.$refs.jibaiseikiDialog.setTableData(data);
        },
        (err: any) => {
          const msg = util.getHttpErrorMessage(err);
          this.$refs.jibaiseikiDialog.getDataError(msg);
        }
      );
    } else {
      this.$refs.jibaiseikiDialog.setTableData(this.jibaiseikiTable);
    }
  }

  onJibaiseiki(param: any) {
    this.formData.zeiJibaisekiZk = +param.value;
    this.formData.zkJibaisekiCd = param.code;
    this.formData.zeiJibaisekiMonthCnt = +param.month;
    this.$refs.taxForm.validateField(
      ["zeiJibaisekiZk", "zeiJibaisekiMonthCnt"],
      () => {}
    );
  }

  focusBtnConfirm() {
    setTimeout(() => {
      this.$refs.btnConfirmTax.$el.focus();
    }, 100);
  }

  showJuuryouzeiDialog() {
    this.$refs.juuryouzeiDialog.onOpen();
    if (this.juuryouzeiKubun == null) {
      this.reqService.getJuuryouzeiKubuns().then(
        (data: any) => {
          this.juuryouzeiKubun = data;
          this.$refs.juuryouzeiDialog.setKubuns(data);
        },
        (err: any) => {
          const msg = util.getHttpErrorMessage(err);
          this.$refs.juuryouzeiDialog.getDataError(msg);
        }
      );
    } else {
      this.$refs.juuryouzeiDialog.setKubuns(this.juuryouzeiKubun);
    }
  }

  onJuuryouzei(param: any) {
    this.formData.zeiWeightTax = +param.value;
    this.formData.zkWeightTaxCd = param.code;
    this.$refs.taxForm.validateField("zeiWeightTax", () => {});
  }

  onChangeWeightTax(value: any) {
    this.formData.zkWeightTaxCd = null;
  }

  onChangeJibaizeiki(value: any) {
    this.formData.zkJibaisekiCd = null;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  ryoukinLabel(ryoukin: Hikazei3) {
    return (
      // ryoukin.ryoukinRankNm +
      // " " +
      util.getNumberThousandSeparate(ryoukin.hikazei3Kingaku) +
      "円"
    );
  }

  setInshidai() {
    this.formData.zeiInshidaiZn = this.hikazei3KingakuSelected;
    this.formData.zeiInshidaiZk = this.hikazei3KingakuSelected;
    this.formData.zeiInshidaiGenka = this.hikazei3KingakuSelected;
    // const ryoukin: Hikazei3 | undefined = this.listRyoukinRank.find(
    //   e => e.ryoukinRankCd == this.ryoukinRankSelected
    // );
    // if (ryoukin) {
    //   this.formData.zeiInshidaiZn = ryoukin.hikazei3Kingaku;
    //   this.formData.zeiInshidaiZk = ryoukin.hikazei3Kingaku;
    //   this.formData.zeiInshidaiGenka = ryoukin.hikazei3Genka;
    // }
  }

  setRyoukinRank() {
    this.formData.ryoukinRankCd = this.ryoukinRankSelected;
    const ryoukin = this.listRyoukinRank.ryoukinRank.filter(data => data.ryoukinRankCd == this.ryoukinRankSelected);
    if (ryoukin.length !== 0) {
      this.hikazei3KingakuSelected = ryoukin[0].hikazei3Kingaku;
      this.formData.zeiInshidaiZn = this.hikazei3KingakuSelected;
      this.formData.zeiInshidaiZk = this.hikazei3KingakuSelected;
      this.formData.zeiInshidaiGenka = this.hikazei3KingakuSelected;
    }
  }

  @Watch("formData.zeiJibaisekiZk")
  onChangeJibaiseiki() {
    if (this.isClearFromButton && this.formData.zeiJibaisekiZk) {
      this.isClearFromButton = false;
      // setTimeout(() => {
      //   this.$refs.taxForm.validateField(
      //     ["zeiJibaisekiZk"],
      //     () => {}
      //   );
      // }, 250);
    }
  }

 get checkValidate () {
    if (this.formData.zeiJibaisekiZk && this.formData.zeiJibaisekiMonthCnt) {
      return true;
    } else if (!this.formData.zeiJibaisekiZk && this.isClearFromButton) {
      return true;
    }
    return false;
  }

  clearJibaiseiki() {
    // clear zeiJibaiseki price, keep zeiJibaisekiMonthCnt, require zeiJibaisekiMonthCnt
    this.isClearFromButton = true;
    this.formData.zeiJibaisekiZk = 0;
    this.formData.zeiJibaisekiZn = 0;
    this.formData.zkJibaisekiCd = null;
    this.$refs.taxForm.validateField(
      ["zeiJibaisekiZk", "zeiJibaisekiMonthCnt"],
      () => {}
    );
  }

  focusNext(index: number) {
    if (this.$refs.inputKingaku[index + 1]) {
      this.$refs.inputKingaku[index + 1].focus();
    } else {
      setTimeout(() => {
        const btnEditShohiyou =  document.getElementById("btnEditShohiyou");
        if (btnEditShohiyou) {
          btnEditShohiyou.focus();
        }
      }, 100);
    }
  }

  beforeDestroy() {
    if (this.isEditPrice) {
      window.sessionStorage.setItem("shouhiyouEditMode", "1");
    } else {
      window.sessionStorage.removeItem("shouhiyouEditMode");
    }
  }

  resetPrice(item: Item) {
    const originalKingakuZk = item.originalKingakuZk || 0;
    if (item.kingakuZk != originalKingakuZk) {
      item.kingakuZk = item.originalKingakuZk;
      item.kingakuZn = item.originalKingakuZn;
      this.onConfirm(0);
    }
  }

  onInputShohiyouKingaku() {
    this.isChangeShohiyou = true;
  }

  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [START] */
  updateKensaHiyou() {
    let promise = this.updateKensaHiyouPM();
    Promise.all([promise]).then(() => {});
    
  }
  updateKensaHiyouPM() {
    let data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      isHikazei: this.costData.kensaHiyou.isHikazei, // 2021-08-23 sh #7361 fix bug. it does not update kensaHiyou.
      subTotalZn: this.costData.kensaHiyou.subTotalZn ? this.costData.kensaHiyou.subTotalZn: 0,
      subTotalZk: this.costData.kensaHiyou.subTotalZk ? this.costData.kensaHiyou.subTotalZk: 0
    }
    let promise = new Promise((resolve, reject) => {
      this.reqService.updateKensaHiyou(data).then(
        (res: any) => {
          this.isEditKensaHiyou = false;
          const userService = new UserService();
          userService.getKensaHiyouPM().then(() => resolve());
        },
        error => {
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
          reject();
        }
      );
    });
    return promise;
  }
  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [END] */

  resetKensaHiyou() {
    this.reqService.resetKensaHiyou(this.uketsukeExtendsId).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyou();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  getTaxWeightFromWeb() {
    this.zeiWeightTaxStaging = 0;
    this.confirmDialogTaxWeightMsg = "";
    this.$set(this, "loading", true);
    this.reqService.getTaxWeightFromWeb(this.uketsukeExtendsId).then(
      (response: any) => {
        this.$set(this, "loading", false);
        if(!response) {
          this.confirmDialogTaxWeightMsg = "重量税の取得に失敗しました";
          this.$refs.confirmDialogTaxWeightErr.onOpen();
        } else if(!response.success) {
          if(response.message) {
            this.confirmDialogTaxWeightMsg = response.message;
          } else {
            this.confirmDialogTaxWeightMsg = "重量税の取得に失敗しました";
          }
          this.$refs.confirmDialogTaxWeightErr.onOpen();
        } else {
          this.zeiWeightTaxStaging = response.weightTaxPrice;
          this.confirmDialogTaxWeightMsg = "取得した重量税(" + response.weightTaxPrice.toLocaleString() + "円)を反映しますか？";
          this.$refs.confirmDialogTaxWeight.onOpen();
        }
      },
      (err: any) => {
        this.$set(this, "loading", false);
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  applyTaxWeight() {
    this.formData.zeiWeightTax = this.zeiWeightTaxStaging;
    /** #6550 2020-12-10 sh [START] */
    this.formData.zkWeightTaxCd = null;
    /** #6550 2020-12-10 sh [END] */
  }

  get isUseRakurakuOss() {
    if (this.costData.shatenExtensionPivotVO && this.costData.shatenExtensionPivotVO.isUseRakurakuOss === 1) {
      return true;
    }
    return false;
  }

  get isMadoguchiInshidai() {
    /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
    // return this.isMadoguchiInshidaiChecked;
    return this.isMadoguchiInshidaiChecked || this.isInshidaiZero;
    /** 2021-12-23 sh #7620 allows to set zero yen. [END */
  }

  onChangeInshidai() {
    if (this.isUseRakurakuOss && !this.isMadoguchiInshidaiChecked) {
      this.hikazei3KingakuSelected = null;
      this.setRyoukinRank();
    } else if (this.isUseRakurakuOss && this.isMadoguchiInshidaiChecked) {
      this.inshidaiMadoguchi = this.costData.shatenExtensionPivotVO.inshidaiMadoguchiKingaku;
    }
    /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
    if (this.isInshidaiZero) {
      this.isInshidaiZero = !this.isInshidaiZero
    }
    /** 2021-12-23 sh #7620 allows to set zero yen. [END] */
  }

  /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
  clearTaxWeight() {
    this.formData.zeiWeightTax = 0;
    this.formData.zkWeightTaxCd = null;
  }
  clearInshidai() {
    this.isInshidaiZero = !this.isInshidaiZero
    if (this.isInshidaiZero) {
      this.inshidaiMadoguchi = 0;
      if (this.isMadoguchiInshidaiChecked) {
        this.isMadoguchiInshidaiChecked = !this.isMadoguchiInshidaiChecked;
      }
    } else {
      this.hikazei3KingakuSelected = null;
      this.setRyoukinRank();
    }
  }

  get btnInshidaiLabel() {
    return !this.isInshidaiZero ? "印紙代0円" : "印紙代選択";
  }
  /** 2021-12-23 sh #7620 allows to set zero yen. [END] */

  /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [START] */
  // onConnect() {
  //   if (this.uketsukeCd && this.uketsukeExtendsId) {
  //     this.sktControll.socketShohiyouReload(this.updateShouhiyou);
  //   }
  // }
  // updateShouhiyou(frame: any) {
  //   this.userService.getShohiyou();
  //   const body = util.getWSData(frame);
  //   this.userService.updateConfirm(body.sknUketsukeUserJouhou);
  // }
  // destroyed() {
  //   this.sktControll.freeSocketResources();
  // }
  /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [END] */

  /** 2021-09-28 sh #7438 implements tech info amount. [START] */
  onChangeTechInfoAmount(isUseTechInfoAmount: boolean)  {
    const saveData = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      useTechInfoAmount: isUseTechInfoAmount ? 1 : 0
    };

    this.reqService.updateUseTechInfoAmount(saveData).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyou();
        userService.getConfirm();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  get isUseTechInfoAmount() {
    return this.costData.houteiHiyou.isUseTechInfoAmount == 1;
  }


  /** 2021-09-28 sh #7438 implements tech info amount. [END] */
}
